import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  Checkbox,
  TextInput,
  Group,
  Modal,
  Radio,
  Textarea,
  Tabs,
  Loader,
  Flex,
  Tooltip,
  rem,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconChevronDown, IconDots, IconPlus } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";
import swal from "sweetalert";

import { DatePickerInput } from "@mantine/dates";
import {
  createBillingInvoices,
  createBillingInvoicesSkypoint,
  getAllBillingInvoices,
  getAllBillingInvoicesSkypoint,
} from "../../../services/billinginvoice";
import SkypointNewconsumer from "./SkypointNewconsumer";
import SkypointInvoiceItemTable from "./SkypointInvoiceitemtable";
import { useNavigate } from "react-router-dom";
import UploadFileSvg from "../../Svgs/UploadFileSvg";
import moment from "moment";
import { Dropzone } from "@mantine/dropzone";
import EmptyUploadFile from "../../Svgs/EmptyUploadFile";
import { FaRegFile } from "react-icons/fa6";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { formatFileSize, showError } from "../../../utils";
import { uploadFileToS3Api } from "../../../utils/PresignedUrlFunction";

const useStyles = createStyles(() => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      paddingTop: "1rem",
      background: "rgb(245, 245, 245)",
    },
  },
  addbox: {
    padding: "12px 12px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },
  formtabs: {},
  tablists: {
    width: "100%",
    marginBottom: "1rem",
    "& .mantine-thcgkg[data-active]": {
      borderColor: "#000",
    },
  },
  tabBtns: {
    width: "50%",
  },
  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    gap: "1rem",
    "@media (max-width:1300px)": {
      // flexDirection: "column",
      // gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  formRowItem: {
    width: "100%",
  },
  selectnumber: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "8px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  radiobox: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px !important",
    fontWeight: 500,
    marginTop: 8,
    "& input": {
      marginTop: 3,
      height: 13,
      width: 13,
    },
    "& input.mantine-1cu6yj8:checked": {
      background: "#000",
      borderColor: "#000",
    },

    "& svg": {
      display: "none",
    },
  },

  datePicker: {
    width: "100%",
    "& .mantine-InputWrapper-label": {
      // marginLeft: 10,
      fontSize: 15,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      background: "#FFF",
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
      height: 48,
      minHeight: 48,
    },
  },

  itembox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    padding: "20px",
    width: "100%",
  },

  recurringbox: {
    marginTop: "24px",
    marginBottom: "24px",
    background: "#f2f2f2",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "center",
    gap: "72px",
    alignItems: "center",
    margin: "auto",
    padding: "6px 13px",
  },

  recuuringselect: {
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "center",
    display: "flex",
  },
}));
const bgColor = "#D9D9D9";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "5px",
      // backgroundColor: bgColor,
      border: "1px solid " + bgColor,

      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",
      borderRadius: "5px",
      // backgroundColor: bgColor,
      border: "1px solid " + bgColor,

      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function SkypointNewInvoices({ state, setState }) {
  const { classes } = useStyles();

  const { profile } = useSelector((state) => state?.profile);

    const {
      skypointProviders,
    } = useSelector((state) => state?.skypointProviders);
  const { settingInvoice } = useSelector(
    (state) => state.settinginvoice
  );
   const { stripeaccounts  } = useSelector(
      (state) => state.settinginvoice
    );

console.log('settingInvoice',settingInvoice);


  const [rows, setRows] = useState([{ name: "", quantity: 1, amount: 0 }]);
  const [recurring, setRecurring] = useState(false);
  const [invoiceNumberOption, setInvoiceNumberOption] = useState("auto");
  const [createconsumer, setCreateConsumer] = useState(false);
  const [expires, setExpires] = useState(true);
 const [editcustomer, setEditcustomer] = useState(false);
  const [isEdit, setIsEdit] = useState("");
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
//  console.log('recurring',recurring);
  const [opened, setOpen] = useState(false);
    const [dateRangeVal, setDateRangeVal] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileSizeError, setFileSizeError] = useState("");
  const [uploadingFiles, setUploadingFiles] = useState(false);

  let uploadedFiles = null;
  const navigate = useNavigate();

  const open = () => setOpen(true);

  const handleRadioChange = async (value) => {
    form.setFieldValue("invoiceNumber", '');
    setInvoiceNumberOption(value);
    if (value === "auto") {
      form.setFieldValue("invoiceNumber", "");
      const response = await getAllBillingInvoicesSkypoint();
      const sortedInvoices = [...(response?.data?.billinginvoice || [])].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      console.log(sortedInvoices);
      if (sortedInvoices.length > 0) {
        const latestInvoice = sortedInvoices[0];
        const numericPart = parseInt(
          latestInvoice.invoiceNumber.replace("INV-", ""),
          10
        );
        const nextNumber = numericPart + 1;
        const newInvoiceNumber = `INV-${String(nextNumber).padStart(6, "0")}`;
        form.setFieldValue("invoiceNumber", newInvoiceNumber);
      } else {
        form.setFieldValue("invoiceNumber", "INV-000001");
      }
    } else {
      form.setFieldValue("invoiceNumber", "");
    }
  };

  const getNextRecurringDate = (startDate, frequency) => {
    const nextDate = new Date(startDate);
  
    switch (frequency.toLowerCase()) {
      case "weekly":
        nextDate.setDate(nextDate.getDate() + 7);
        break;
      case "monthly":
        nextDate.setMonth(nextDate.getMonth() + 1);
        break;
      case "yearly":
        nextDate.setFullYear(nextDate.getFullYear() + 1);
        break;
      case "every two months":
        nextDate.setMonth(nextDate.getMonth() + 2);
        break;
      default:
        return null; 
    }
  
    return nextDate;
  };
  

  // const handleRadioChange = (value) => {
  //   setInvoiceNumberOption(value);
  //   if (value === "auto") {
  //     const newInvoiceNumber = `INV-${String(
  //       Math.floor(Math.random() * 10000)
  //     ).padStart(4, "0")}`;
  //     form.setFieldValue("invoiceNumber", newInvoiceNumber);
  //   } else {
  //     form.setFieldValue("invoiceNumber", "");
  //   }
  // };

  const form = useForm({
    initialValues: {
      consumer: "",
      invoiceNumber: "",
      invoiceTitle: "",
      invoiceCreatedDate:new Date(), 
      invoiceDueDate: null,
      notes: "",
      term: "",
      Frequency: null,
      recurringDate: new Date(),
      recurringEndDate: null,
    },
  });

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (invoiceNumberOption === "auto") {
    handleRadioChange("auto")
    }
  }, []);

  useEffect(() => {
    const { invoiceCreatedDate, term } = form.values;

    if (invoiceCreatedDate && term !== "") {
      let dueDate = null;

      // Calculate due date based on selected term
      if (term === "net5") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 5); // Add 5 days to invoice date
      } else if (term === "net10") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 10); // Add 10 days to invoice date
      } else if (term === "net15") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 15); // Add 15 days to invoice date
      } else if (term === "net30") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 30); // Add 30 days to invoice date
      } else if (term === "net45") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 45); // Add 45 days to invoice date
      } 
      else if (term === "endofmonthdue") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setMonth(dueDate.getMonth() + 1);
        dueDate.setDate(1);
        dueDate.setDate(dueDate.getDate() - 1);
      } 
      
     else if (term === "dueonreceipt") {
        dueDate = new Date(); 
      }

      else if (term === "dueendofnextmonth") {
        // Get last date of the next month
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setMonth(dueDate.getMonth() + 2);
        dueDate.setDate(0); // Set it to the last day of the next month
      }

        if (term !== "custom" && dueDate) {
  const currentDueDate = form.values.invoiceDueDate
    ? new Date(form.values.invoiceDueDate)
    : null;

  // Only update if it's different
  if (!currentDueDate || currentDueDate.getTime() !== dueDate.getTime()) {
    form.setFieldValue("invoiceDueDate", dueDate);
  }
}     
    }
  }, [form.values.invoiceCreatedDate, form.values.term]);

  const renderContent = (value) => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <div className={classes.formRow}>
              <Box className={classes.formRowItem}>
                <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                  Provider Name
                </Text>
                <Box className={classes.boxnumber}>
                  <CustomSelectBox
                    id="billing-type"
                    placeholder={"Select or Add a new name"}
                    withAsterisk
                    searchable
                    data={(
                      skypointProviders || []
                    ).map((item) => ({
                      value: item?.id,
                      label: item?.name,
                    }))}
                    {...form.getInputProps("consumer")}
                  />
                </Box>
                {/* Add a clickable div for "Add New Consumer" */}
                {/* <div
                  style={{
                    cursor: "pointer",
                    color: "#FD853A",
                    marginTop: "8px",
                    fontWeight: "bold",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  onClick={() => navigate(`/home/provider-skypoint/add`)}
                >
                  + Add Provider
                </div> */}
              </Box>
              <Box className={classes.formRowItem}>
                <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                  Invoice Number
                </Text>
                <Box className={classes.boxnumber}>
                  {invoiceNumberOption === "auto" &&
                  form.values.invoiceNumber === "" ? (
                    <Loader color="yellow" size={"md"} />
                  ) : (
                    <CustomTextInput
                      id="invoice-Number"
                      disabled={invoiceNumberOption === "auto"}
                      size="sm"
                      placeholder={"INV-000001"}
                      withAsterisk
                      value={form.values.invoiceNumber}
                      onChange={(e) =>
                        form.setFieldValue("invoiceNumber", e.target.value)
                      }
                    />
                  )}

                  {/* <Box className={classes.line}></Box> */}
                </Box>
                <div>
                  <Group>
                    <Radio
                      className={classes.radiobox}
                      checked={invoiceNumberOption === "auto"}
                      label="Auto-Generated"
                      value="auto"
                      onChange={() => handleRadioChange("auto")}
                    />
                    <Radio
                      className={classes.radiobox}
                      checked={invoiceNumberOption === "manual"}
                      label="Manual"
                      value="manual"
                      onChange={() => handleRadioChange("manual")}
                    />
                  </Group>
                </div>
              </Box>
            </div>
            <div className={classes.formRow}>
              <Box className={classes.formRowItem}>
                <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                  Invoice Title
                </Text>
                <Box className={classes.boxnumber}>
                  <CustomTextInput
                    id="invoice-Title"
                    size="sm"
                    placeholder={"Enter Invoice Title"}
                    withAsterisk
                    {...form.getInputProps("invoiceTitle")}
                    // disabled={isPreview}
                  />
                </Box>
              </Box>

              <Box className={[classes.datePicker, classes.formRowItem]}>
                <DatePickerInput
                  id="invoice-date"
                  label="Invoice Date"
                  size="xl"
                  placeholder="mm/dd/yyyy"
                  rightSection={
                    <img
                      style={{ width: "30px" }}
                      src={"/assets/images/calendar-icon.png"}
                      alt="Icon"
                    />
                  }
                  // withAsterisk
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  {...form.getInputProps("invoiceCreatedDate")}

                  //   disabled={isPreview}
                />
              </Box>
            </div>
            <div className={classes.formRow}>
              <Box className={classes.formRowItem}>
                <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                  Invoice Term
                </Text>
                <Box className={classes.boxnumber}>
                  <CustomSelectBox
                    id="billing-type"
                    placeholder={"Select Invoice Term"}
                    withAsterisk
                    searchable
                    data={[
                      { value: "net5", label: "Net 5" },
                      { value: "net10", label: "Net 10" },
                      { value: "net15", label: "Net 15" },
                      { value: "net30", label: "Net 30" },
                      { value: "net45", label: "Net 45" },
                      {
                        value: "endofmonthdue",
                        label: "Due End of Month",
                      },
                      { value: "dueonreceipt", label: "Due on receipt" },

                      {
                        value: "dueendofnextmonth",
                        label: "Due End of Next Month",
                      },
                      { value: "custom", label: "Custom" },

                    ]}
                    {...form.getInputProps("term")}
                  />
                </Box>
              </Box>

              <Box className={[classes.datePicker, classes.formRowItem]}>
                <DatePickerInput
                  id="due-date"
                  label="Due Date"
                  size="xl"
                  placeholder="mm/dd/yyyy"
                  rightSection={
                    <img
                      style={{ width: "30px" }}
                      src={"/assets/images/calendar-icon.png"}
                      alt="Icon"
                    />
                  }
                  // withAsterisk
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  {...form.getInputProps("invoiceDueDate")}
                  disabled={form.values.term !== "custom"}
                />
              </Box>
            </div>
            {value === "recurring" ? (
              <>
                <Box className={classes.recuuringselect}>
                  <Text
                    ff={"Inter"}
                    fz={14}
                    fw={500}
                    color="#262626"
                    style={{ width: "100%" }}
                  >
                    Select Frequency
                    <CustomSelectBox
                      placeholder="Select frequency"
                      default="weekly"
                      data={[
                        { value: "weekly", label: "Weekly" },
                        { value: "monthly", label: "Monthly" },
                        { value: "yearly", label: "Yearly" },
                        {
                          value: "Every two Months",
                          label: "Every two Months",
                        },
                      ].map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      // value={selectedCode?.id}
                      // onChange={handleSelectChange}
                      {...form.getInputProps("Frequency")}
                    />
                  </Text>
                </Box>
                <Box style={{ gap: "10px" }} className={classes.dflex}>
                  <Box className={classes.formRowItem}>
                    <DatePickerInput
                      // id="due-date"
                      // label="Due Date"
                      label="Recurring Start Date *"
                      size="lg"
                      placeholder="mm/dd/yyyy"
                      rightSection={
                        <img
                          style={{ width: "30px" }}
                          src={"/assets/images/calendar-icon.png"}
                          alt="Icon"
                        />
                      }
                      // withAsterisk
                      styles={{
                        rightSection: { pointerEvents: "none" },
                      }}
                      {...form.getInputProps("recurringDate")}
                      //   disabled={isPreview}
                    />
                  </Box>

                  <Box className={[classes.datePicker, classes.formRowItem]}>
                    <DatePickerInput
                      // id="due-date"
                      label="Recurring End Date"
                      size="lg"
                      disabled={expires}
                      placeholder="mm/dd/yyyy"
                      rightSection={
                        <img
                          style={{ width: "30px" }}
                          src={"/assets/images/calendar-icon.png"}
                          alt="Icon"
                        />
                      }
                      // withAsterisk
                      styles={{
                        rightSection: { pointerEvents: "none" },
                      }}
                      {...form.getInputProps("recurringEndDate")}
                      //   disabled={isPreview}
                    />
                    {/* <Box> */}
                    <Checkbox
                      label="Never Expires"
                      sx={{
                        marginTop: 8,
                        "& input:checked": {
                          background: "#000",
                          borderColor: "#000",
                        },
                        "& input:checked": {
                          background: "#000",
                          borderColor: "#000",
                        },
                      }}
                      defaultChecked={expires}
                      onChange={(v) => {
                        setExpires(v?.target?.checked);
                      }}
                      //disabled={view}
                      color="yellow"
                    />
                    {/* </Box> */}
                  </Box>
                </Box>
              </>
            ) : null}
            <Text
              style={{ marginTop: "28px", marginBottom: "15px" }}
              ff={"Inter"}
              fz={18}
              fw={600}
              color="#000"
            >
              {/* Intervention Details */}
              Invoice Description
            </Text>

            <Box className={classes.itembox}>
              <SkypointInvoiceItemTable rows={rows} setRows={setRows} isPreview={isPreview}
                dateRangeVal={dateRangeVal}
                setDateRangeVal={setDateRangeVal} />

                {!recurring ? <>
                
                  <Box style={{ marginTop: "20px", marginBottom: "20px" }}>
                                <Button
                                  leftIcon={<UploadFileSvg size={20} />}
                                  color="yellow"
                                  onClick={open}
                                  style={{ color: "black" }}
                                >
                                  {files && files.length > 0
                                    ? "Upload more Files"
                                    : "Upload Files"}
                                </Button>
                
                                {files && files.length > 0 && (
                                  <Box mt="10px">
                                    <strong>Uploaded Files:</strong>
                                    <ul style={{ margin: "5px 0", paddingLeft: "20px" }}>
                                      {files.map((file, index) => (
                                        <li key={index}>{file.name}</li>
                                      ))}
                                    </ul>
                                  </Box>
                                )}
                              </Box>
                
                </>:null}

              {/* <Text style={{background: '#E5E5E5'}}  ff={"Inter"} fz={14} fw={600} color="#262626">Item Table</Text> */}
              <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
                <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                  Notes
                </Text>
              </Box>

              <Textarea
                //   label="Input label"
                //   description="Input description"
                autosize
                minRows={6}
                placeholder="Enter Notes"
                {...form.getInputProps("notes")}
              />
            </Box>

            {/* <Box className={classes.recurringbox}>
              <Box>
                <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                  Make Reoccurring
                  <Checkbox
                    // label="No Guardian"
                    // ref={noGuardianRef}
                    // defaultChecked={form2?.noGuardian}
                    // {...form.getInputProps("noGuardian")}
                    // sx={{ marginTop: 20 }}
                    onChange={(v) => setRecurring(v?.target?.checked)}
                    //disabled={view}
                    color="yellow"
                  />
                </Text>
              </Box>
            </Box> */}

            <Box
              style={{ marginTop: "20px", marginBottom: "20px" }}
              className={classes.formRow}
            >
              <Button
                variant="filled"
                onClick={handleClose}
                c={"#000"}
                style={{ width: "100%", background: "#F5F5F5" }}
                // className={classes.backNextBtn}
                size="md"
              >
                Save as Draft
              </Button>

              <Button
                onClick={onSave}
                variant="filled"
                style={{ width: "100%" }}
                c={"#000"}
                loading={loading}
                radius={"md"}
                size="md"
                color="yellow"
                // className={classes.backNextBtn}
              >
                Send
              </Button>
            </Box>
          </>
        );

      default:
        return null;
    }
  };


  const handleTabChange = (value) => {

    if (value === 'recurring') {
      setRecurring(true); 
      setInvoiceNumberOption('auto') 
      handleRadioChange("auto")
    } else {
      setRecurring(false); 
      setInvoiceNumberOption('auto') 
      handleRadioChange("auto")
    }
  };

  const onSave = async () => {
    const values = form.values;

if (!settingInvoice?.settinginvoice){ 

  swal("Error", "Profile Incomplete !! Please Update Your Profile in Setting tab", "error");
  return

}


    // console.log("values", values);
    // console.log("rows", rows);


    if (Array.isArray(rows)) {
      const invalidRow = rows.find(row => row.amount <= 0 );
    
      if (invalidRow) {
        swal("Error", "Invoice amount must be greater than $0", "error");
        return
        
      } 
   
    
    } 

    if (!values.Frequency && recurring) {
          swal("Error", "frequency is required for recurring invoices", "error");
          return;
        }

    
        let startDate=null;
            let endDate=null;
            if (dateRangeVal?.length > 0){
             startDate = moment(dateRangeVal[0]).startOf("day");
             endDate = moment(dateRangeVal[1]).endOf("day");
            }

    const calculateTotal = () =>
      rows.reduce((total, row) => total + row.quantity * row.amount, 0);

      setLoading(true)

    let payload = {
      ...values,
      interventionDetails: rows,
      totalAmount: calculateTotal().toFixed(2),
      recurring:recurring,
      recurringNextDate: recurring
      ? getNextRecurringDate(values.invoiceCreatedDate, values.Frequency)
      : null,
      InvoiceNumberType:invoiceNumberOption,
      contractor: profile.user.id,
      serviceStartDate: startDate,
      serviceEndDate: endDate,
      documents:files
    };

    console.log("payload", payload);

    const res = await createBillingInvoicesSkypoint(payload);

    if (res.status === 200) {
      let payload={
        page:1
      }
      getAllBillingInvoicesSkypoint(payload);
      swal({
        title: `Invoice created successfully`,
        text: "Invoice Created successfully",
        dangerMode: false,
      });
      form?.reset();
      setRecurring(false);
      setRows([]);
      setInvoiceNumberOption('manual')
       setFiles([])
      setSelectedFile(null);
      setLoading(false)
  
      handleClose();
    }

    setLoading(false)
  };
  const handleClose = () => {
    setDateRangeVal([]);
    setState(false);
    // setState((prevState) => ({
    //   ...prevState,
    //   addProvider: false,
    // }));
  };

    // Function to upload files to S3 immediately when selected
  const handleFileDrop = async (newFiles) => {
    setUploadingFiles(true);
    setFileSizeError("");

    try {
      // Upload new files to S3 immediately
      const uploadedToS3 = await Promise.all(
        newFiles.map(async (file) => {
          const result = await uploadFileToS3Api({ file });
          return {
            name: file.name,
            url: result?.uploadURL,
            size: file.size,
            type: file.type,
          };
        })
      );

      // Update files state with S3 URLs
      const updatedFiles = [...files, ...uploadedToS3];
      setFiles(updatedFiles);

      // Set first file as selected if no file is currently selected
      if (!files?.length) {
        setSelectedFile(updatedFiles[0]);
      }
    } catch (error) {
      showError(error?.message || "File upload to S3 failed");
    } finally {
      setUploadingFiles(false);
    }
  };
  const unsupportedTypes = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const fileType = selectedFile?.type;

  const Content = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className={classes.uploadFileContainer} style={{ flex: 1 }}>
          <div className={classes.dropzone}>
            <Dropzone
              onDrop={handleFileDrop}
              onReject={(files) => {
                // Handle rejected files if needed
              }}
              disabled={uploadingFiles}
            >
              <Group
                position="center"
                spacing="xl"
                style={{ minHeight: rem(220), pointerEvents: "none" }}
              >
                <Dropzone.Accept></Dropzone.Accept>
                <Dropzone.Reject></Dropzone.Reject>
                <Dropzone.Idle></Dropzone.Idle>

                <Flex direction={"column"} align={"center"}>
                  {uploadingFiles ? (
                    <>
                      <Loader size="md" />
                      <Text size="md" inline mt={10}>
                        Uploading files...
                      </Text>
                    </>
                  ) : (
                    <>
                      <EmptyUploadFile />
                      <Text size="md" inline>
                        <u>Click to Upload</u> or Drag and Drop
                      </Text>
                    </>
                  )}
                </Flex>
              </Group>
            </Dropzone>
            {fileSizeError && (
              <Text color="red" size="sm" mt={10}>
                {fileSizeError}
              </Text>
            )}

            {/* {files?.length > 1 && (
              <Text color="red" size="sm" mt={10}>
                You can only update one file at a time.
              </Text>
            )} */}
          </div>
          {files?.length > 0 ?  <>
            <Text>File Upload</Text>
          </>:null}
          <Flex ml={20} justify={"flex-start"}>
          
          </Flex>
          {!files?.length && uploadedFiles ? (
            <Box className={classes.row}>
              <Box className={classes.column2}>
                <Box className={classes.fileItem}>
                  <Flex align={"center"} gap={5}>
                    <FaRegFile size={15} />
                    <Tooltip label={uploadedFiles?.name}>
                      <Text lineClamp={1} w={180}>
                        {uploadedFiles?.name}
                      </Text>
                    </Tooltip>
                  </Flex>
                  <Text lineClamp={1} w={180} className={classes.fileSize}>
                    {/* {`Size ${value?.size}`} */}
                  </Text>
                </Box>
              </Box>

              <Box className={classes.column2}>
                <Box className={classes.fileExpiryContainer}>
                  <Box className={classes.fileName}>
                    <Text fw={600} ff={"Inter"} fz={14}>
                      Expiry Date:
                    </Text>
                    <Text>
                      {moment(uploadedFiles?.expiry)?.format("MM/DD/YYYY")}
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : null}
          {files?.length ? (
            <Box className={classes.row} style={{ width: "100%" }}>
              <Box className={classes.column2} style={{ width: "100%" }}>
                {files?.map((value, index) => (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: selectedFile ? "column" : "row",
                      justifyContent: selectedFile ? "flex-start" : "center",
                      alignItems: selectedFile ? "start" : "center",
                      marginLeft: selectedFile && "10px",
                    }}
                  >
                    <Box
                      className={classes.fileItem}
                      onClick={() => setSelectedFile(value)}
                    >
                      <Flex align={"center"} gap={5}>
                        <FaRegFile size={15} />
                        <Tooltip label={value?.name}>
                          <Text lineClamp={1} w={180}>
                            {value?.name}
                          </Text>
                        </Tooltip>
                      </Flex>
                      <Text lineClamp={1} w={180} className={classes.fileSize}>
                        {`Size ${formatFileSize(value?.size)}`}
                      </Text>
                    </Box>
                  </div>
                ))}
              </Box>
            </Box>
          ) : null}
        </div>

        {(selectedFile || uploadedFiles) && (
          <div
            style={{
              marginRight: "10px",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid #E4E4E7",
            }}
          >
            <p style={{ fontWeight: 600 }}>Document Preview</p>
            {unsupportedTypes?.includes(fileType) ? (
              <Flex align={"center"} justifyContent={"center"} gap={5} h={550}>
                This file type is not supported for preview.
              </Flex>
            ) : (
              <DocViewer
                style={{
                  borderTop: "1px solid #E4E4E7",
                  width: "100%",
                  height: 550,
                  overflowY: "auto",
                }}
                config={{ header: { disableHeader: true } }}
                key={1}
                documents={[
                  selectedFile
                    ? {
                        uri: selectedFile.url, // Now using S3 URL instead of createObjectURL
                        fileType: selectedFile.url?.split(".").pop(),
                      }
                    : {
                        uri: uploadedFiles?.fileUrl,
                        fileType: uploadedFiles?.fileUrl?.split(".").pop(),
                      },
                ]}
                pluginRenderers={DocViewerRenderers}
              />
            )}
          </div>
        )}
      </div>
    );
  };



  const savefiles = () => {
    setOpen(false);
  };

  const close = () => {
    setOpen(false);
    setFiles([]);
    setSelectedFile(null);
  };

  return (
    <>
      <Modal
        opened={state}
        size={1000}
        title={
          <div style={{ fontSize: "1.3rem", fontWeight: 700 }}>
            Create New Invoice
          </div>
        }
        shadow="md"
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        radius={"lg"}
        zIndex={1000}
        className={classes.modalBody}
        centered
      >
        <Box>
          <form>
            <Box className={classes.addbox}>
              <Tabs defaultValue="oneTime" className={classes.formtabs} onTabChange={handleTabChange}>
                <Tabs.List className={classes.tablists}>
                  <Tabs.Tab className={classes.tabBtns} value="oneTime">
                    One Time
                  </Tabs.Tab>
                  <Tabs.Tab className={classes.tabBtns} value="recurring">
                    Recurring
                  </Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="oneTime">
                  {renderContent("oneTime")}
                </Tabs.Panel>
                <Tabs.Panel value="recurring">
                  {renderContent("recurring")}
                </Tabs.Panel>
              </Tabs>
            </Box>
          </form>
        </Box>
      </Modal>

      <SkypointNewconsumer
        // createconsumer={createconsumer}
        // setCreateConsumer={setCreateConsumer}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        setIsPreview={setIsPreview}
        setEditcustomer={setEditcustomer}
        customer={customer}
        setCustomer={setCustomer}
        editcustomer={editcustomer}
        createconsumer={createconsumer}
        setCreateConsumer={setCreateConsumer}
      />

       <Modal
              opened={opened}
              shadow="md"
              overlayProps={{ blur: 3 }}
              onClose={close}
              className={classes.uploadModal}
              size={1000}
              // withCloseButton={isPendingAction || isnotificationdoc ? true : false}
              zIndex={1000}
              centered
            >
              <Content />
              <Group grow m={10}>
                <Button
                  fullWidth
                  color="gray"
                  variant="light"
                  c={"#000"}
                  onClick={close}
                  style={{ width: "50%" }}
                >
                  Cancel
                </Button>
      
                <Button
                  fullWidth
                  variant="filled"
                  onClick={savefiles}
                  color="yellow"
                  c="#000"
                  style={{ width: "50%" }}
                >
                  Save
                </Button>
              </Group>
            </Modal>
    </>
  );
}

export default SkypointNewInvoices;
